import { render, staticRenderFns } from "./MerchantChannelTypeStatistics.vue?vue&type=template&id=30cd09f7&"
import script from "./MerchantChannelTypeStatistics.vue?vue&type=script&lang=ts&"
export * from "./MerchantChannelTypeStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantChannelTypeStatistics.vue"
export default component.exports